<template>
	<div class="page">
		<van-nav-bar :title="xuanfeidata.goods_name" class="nav-bar newnavbar">
			<template #left>
				<van-icon name="arrow-left" color="#fff" @click="back()" />
			</template>
		</van-nav-bar>
		<div class="feiziInfo">
			<div class="topInfo">
				<div>
					<span>{{ xuanfeidata.goods_name || '' }}</span>
				</div>
				<div>{{ $t('personHeight') }}: {{ xuanfeidata.shop_name }} {{ $t('bust') }}：{{ xuanfeidata.goods_price
					}}</div>
				<div>
					<div v-for="v in (xuanfeidata.flag || '').split(',')" :key="v">{{ v }}</div>
				</div>
				<div style="display: flex;">
					<span style="font-size: 14px;">{{ $t('tollRange') }}：</span>
					<van-rate style="display: flex;" v-model="xuanfeidata.rate" color="#795548" void-color="#fff"
						readonly size="15" />
				</div>
				<div style="font-size: 14px;margin: 4px 0;">
					{{ $t('residence') }}：{{ LangData[$i18n.locale] }}
				</div>
				<div class="yuyueBox" @click="yuyue">{{ $t('reservationNow') }}</div>
				<div class="dianzanimg" @click="dzFn">
					<van-image fit="cover" width="60" height="60" src="img/zan.png" />
					<p style="margin: 0;">{{ dianzannum }}</p>
				</div>
			</div>
			<div class="cenInfo">
				<div>
					<div class="imgswiper">
						<div style="margin-right: 10px;" v-for="(v, i) in xuanfeidata.img_url" :key="i"
							@click="choseedImg(v, i)">
							<van-image fit="cover" width="100" height="100" class="imgI" :class="{ active: imgI == i }"
								:src="v" />
						</div>
					</div>
					<van-image fit="cover" width="100%" height="635" :src="choseImg" @click="ImagePreview" />
				</div>
			</div>
			<div class="btmInfo">
				<div style="color: #000;margin-bottom: 10px;font-weight: bold;">{{ $t('personalProfile') }}</div>
				<div style="color: #323233;" v-html="xuanfeidata.goods_info"></div>
			</div>
		</div>
	</div>
</template>

<script>
import { ImagePreview } from 'vant';
export default {
	data() {
		return {
			xuanfeidata: {
				img_url: [],
			},
			imgI: 0,
			choseImg: '',
			dianzannum: 0,
		};
	},
	created() {
		this.getxuanfeidata();
	},
	methods: {
		back() {
			this.$router.go(-1);
		},
		getxuanfeidata() {
			this.$httpNew({
				method: 'get',
				url: 'get_goods_detail',
				data: { id: this.$route.query.id }
			}).then(res => {
				this.xuanfeidata = res.good || {};
				this.dianzannum = this.xuanfeidata.dianzan;
				this.xuanfeidata.img_url = this.xuanfeidata.img.split("|") || [];
				this.choseImg = this.xuanfeidata.img_url[0];
			});
		},
		yuyue() {
			this.$toast(this.$t('completeActivationTask'));
			/* this.$httpNew({
				method: 'get',
				url: 'get_withdrawal',
				data: {
					page: 1,
					limit: 10,
				},
			}).then(res => {
				if (res.code == 0 && res.data && res.data.length) {
					this.$toast(this.$t('appointmentSuccessful'));
				} else {
					this.$toast(this.$t('completeActivationTask'));
				}
			}) */
		},
		ImagePreview() {
			ImagePreview([this.choseImg]);
		},
		choseedImg(v, i) {
			this.imgI = i;
			this.choseImg = v;
		},
		dzFn() {
			if (this.xuanfeidata.dianzan == this.dianzannum) {
				this.dianzannum++;
			} else if (this.xuanfeidata.dianzan < this.dianzannum) {
				this.dianzannum--;
			}
		},
	},
};
</script>

<style lang="less" scoped>
::v-deep .vjs-big-play-button {
	// top: 50%;
	// left: 50%;
	// margin-top: -50px;
	// margin-left: -100px;
	top: 50% !important;
	left: 50% !important;
	transform: translate(-50%, -50%) !important;
	width: 120px !important;
	height: 80px !important;
	line-height: 80px !important;
	font-size: 50px !important;
}

.video-js {
	width: 100%;
	// height: 420px;
	font-size: 24px;
}

.feiziInfo {
	background: #ebedf0;

	>div {
		padding: 30px 20px;
		background: #fff;
		margin-bottom: 30px;
	}

	.topInfo {
		position: relative;
		color: #000000;

		>div:nth-child(1) {
			font-weight: 600;
			font-size: 36px;
		}

		>div:nth-child(2) {
			font-size: 24px;
			margin: 10px 0;
		}

		>div:nth-child(3) {
			width: 50%;

			>div {
				background: linear-gradient(90deg, #323233, #000000);
				color: #fff;
				display: inline-block;
				border-radius: 10px;
				margin-right: 15px;
				font-size: 12px;
				padding: 8px;
				margin-bottom: 15px;
			}

			>div:nth-child(5) {
				margin-right: 120px;
			}
		}

		.yuyueBox {
			position: absolute;
			right: 30px;
			bottom: 20px;
			color: #fff;
			padding: 10px 15px;
			background: linear-gradient(90deg, #323233, #000000);
			border-radius: 50px;
		}

		.dianzanimg {
			position: absolute;
			top: 30px;
			right: 50px;
			text-align: center;
		}
	}

	.cenInfo {
		.van-tab__text {
			font-size: 18px;
		}

		.imgswiper {
			width: 100%;
			overflow-x: scroll;
			margin: 30px 0;
			display: flex;
			flex-wrap: nowrap;

			>div {
				.imgI.active {
					border: 5px solid #323233;
				}


			}
		}

	}
}

.container {
	display: inline-block;
}

.newnavbar {
	height: 100px;
	background: #000000 !important;
}

.box {
	width: 95%;
	margin: 0 auto;
	text-align: center;
	padding-bottom: 6.25rem;
}

.name {
	font-size: 1.125rem;
}

.title {
	font-size: 0.625rem;
}

.button {
	width: 10rem;
	height: 2.5rem;
	font-size: 0.9375rem;
	margin-top: 0.625rem;
}
</style>
